import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';

const PayorTable = ({ data, loading, onPageChange, onPageSizeChange, pageFilter }) => {
  const [state, updateState] = useState({
    detailModal: false,
  });

  //const { data, loading, currentPage, pageSize, records } = state;

  const setState = obj => updateState(pre => ({ ...pre, ...obj }));
  const columns = [
    {
      dataField: 'BIN',
      text: 'BIN',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'PCN',
      text: 'PCN',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'Group',
      text: 'Group',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'Reason',
      text: 'Reason',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'startDate',
      text: 'Start Date',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'endDate',
      text: 'End Date',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
  ]
    return (
    <div
      className="table-card scroll-table position-relative border-0 rounded pt-0"
      fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id={'reportsTable'}
        hasPagination
        loading={loading}
        data={data}
        columns={columns}
        onExport={() => ''}
        pageSize={pageFilter.pageSize}
        currentPage={pageFilter.page}
        totalRecords={pageFilter.records}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  )
}

export default PayorTable;